// import React, { useState, useRef } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './WheelScreen.css';

// function WheelScreen() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { match, amount } = location.state || {};
//   const [isSpinning, setIsSpinning] = useState(false);
//   const [result, setResult] = useState(null);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const wheelRef = useRef(null);

//   // Add hover effect to wheel segments
//   const handleSegmentHover = (index) => {
//     if (!isSpinning && !result) {
//       const segments = document.querySelectorAll('.wheel-segment');
//       segments.forEach((segment) => {
//         segment.style.filter = 'brightness(0.5)';
//       });
//       segments[index].style.filter = 'brightness(1.2)';
//     }
//   };

//   const handleSegmentLeave = () => {
//     if (!isSpinning && !result) {
//       const segments = document.querySelectorAll('.wheel-segment');
//       segments.forEach((segment) => {
//         segment.style.filter = 'brightness(1)';
//       });
//     }
//   };

//   const handleSpin = () => {
//     if (isSpinning) return;
    
//     setIsSpinning(true);
//     const spinDuration = 4000; // 4 seconds
//     const rotations = 8; // Number of full rotations
    
//     // Generate a random multiplier between 1x and 15x
//     const randomMultiplier = Math.floor(Math.random() * 15) + 1;
    
//     // Calculate the final rotation angle - align with pointer at top
//     const segmentAngle = 360 / 15;
//     const finalAngle = (rotations * 360) + ((15 - randomMultiplier) * segmentAngle) - 10;
    
//     // Apply the rotation animation with easing
//     wheelRef.current.style.transition = `transform ${spinDuration}ms cubic-bezier(0.17, 0.67, 0.83, 0.67)`;
//     wheelRef.current.style.transform = `rotate(${-finalAngle}deg)`;
    
//     // Set the result after the spin and show confetti
//     setTimeout(() => {
//       setResult(randomMultiplier);
//       setIsSpinning(false);
//       setShowConfetti(true);
      
//       // Hide confetti after 5 seconds
//       setTimeout(() => {
//         setShowConfetti(false);
//       }, 5000);
//     }, spinDuration);
//   };

//   const handleConfirm = () => {
//     // Make sure we have valid values for multiplier and amount
//     const finalMultiplier = result || 1;
//     const finalAmount = amount || 0;
    
//     console.log("WheelScreen sending:", {
//       multiplier: finalMultiplier,
//       amount: finalAmount,
//       match: match
//     });
    
//     navigate('/quiz', {
//       state: {
//         multiplier: finalMultiplier,
//         amount: finalAmount,
//         match: match
//       }
//     });
//   };

//   if (!match || !amount) {
//     return (
//       <div className="wheel-screen">
//         <div className="error-message">Invalid bet details</div>
//       </div>
//     );
//   }

//   return (
//     <div className="wheel-screen">
//       {/* <div className="wheel-header">
//         <button className="back-button" onClick={() => navigate(-1)}>
//           <span>←</span> Back
//         </button>
//         <h1>4 ka 100 Wheel</h1>
//       </div> */}

//       <div className="wheel-container">
//         <div className="wheel" ref={wheelRef}>
//           {[...Array(15)].map((_, i) => (
//             <div 
//               key={i} 
//               className="wheel-segment"
//               style={{ transform: `rotate(${i * (360 / 15)}deg)` }}
//               onMouseEnter={() => handleSegmentHover(i)}
//               onMouseLeave={handleSegmentLeave}
//             >
//               <div className="segment-value">{15 - i}x</div>
//             </div>
//           ))}
//         </div>
//         <div className="wheel-pointer"></div>
//       </div>

//       <div className="bet-info">
//         <div className="bet-amount">
//           <span>Stake Amount:</span>
//           <span className="amount">₹{amount}</span>
//         </div>
//         {result && (
//           <>
//           <div className="result">
//             <span>Multiplier:</span>
//             <span className="multiplier">{result}x</span>
//           </div>
//             <div className="result">
//             <span>Total Winnings:</span>
//             <span className="multiplier">₹{amount * result}</span>
//           </div>
//           </>
//         )}
//       </div>

//       <div className="action-buttons">
//         {!result ? (
//           <button 
//             className="spin-button"
//             onClick={handleSpin}
//             disabled={isSpinning}
//           >
//             {isSpinning ? (
//               <>
//                 <span className="spinner"></span>
//                 Spinning...
//               </>
//             ) : (
//               'Spin Wheel'
//             )}
//           </button>
//         ) : (
//           <button 
//             className="confirm-button"
//              style={{ width: '100%' }}
//             onClick={handleConfirm}
//            >
//             Confirm Bet
//           </button>
//         )}
//       </div>

//       {showConfetti && (
//         <div className="confetti-container">
//           {[...Array(50)].map((_, i) => (
//             <div 
//               key={i}
//               className="confetti"
//               style={{
//                 left: `${Math.random() * 100}%`,
//                 animationDelay: `${Math.random() * 3}s`,
//                 backgroundColor: `hsl(${Math.random() * 360}, 100%, 50%)`
//               }}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// export default WheelScreen; 



import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './WheelScreen.css';

function WheelScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { match, amount } = location.state || {};
  const [isSpinning, setIsSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const wheelRef = useRef(null);

  // Hover effect on segments
  const handleSegmentHover = (index) => {
    if (!isSpinning && !result) {
      const segments = document.querySelectorAll('.wheel-segment');
      segments.forEach((segment) => {
        segment.style.filter = 'brightness(0.5)';
      });
      segments[index].style.filter = 'brightness(1.2)';
    }
  };

  const handleSegmentLeave = () => {
    if (!isSpinning && !result) {
      const segments = document.querySelectorAll('.wheel-segment');
      segments.forEach((segment) => {
        segment.style.filter = 'brightness(1)';
      });
    }
  };

  const handleSpin = () => {
    if (isSpinning) return;

    setIsSpinning(true);
    const spinDuration = 4000;
    const rotations = 8;
    const randomMultiplier = Math.floor(Math.random() * 15) + 1;
    const segmentAngle = 360 / 15;
    const finalAngle = (rotations * 360) + ((15 - randomMultiplier) * segmentAngle) - 10;

    wheelRef.current.style.transition = `transform ${spinDuration}ms cubic-bezier(0.17, 0.67, 0.83, 0.67)`;
    wheelRef.current.style.transform = `rotate(${-finalAngle}deg)`;

    setTimeout(() => {
      setResult(randomMultiplier);
      setIsSpinning(false);
      setShowConfetti(true);

      setTimeout(() => {
        setShowConfetti(false);
      }, 5000);
    }, spinDuration);
  };

  // Memoized confirm function to prevent ESLint warning
  const handleConfirm = useCallback(() => {
    const finalMultiplier = result || 1;
    const finalAmount = amount || 0;

    console.log("WheelScreen sending:", {
      multiplier: finalMultiplier,
      amount: finalAmount,
      match: match
    });

    navigate('/quiz', {
      state: {
        multiplier: finalMultiplier,
        amount: finalAmount,
        match: match
      }
    });
  }, [result, amount, match, navigate]);

  // Auto navigate after 3 seconds when result is available
  useEffect(() => {
    if (result) {
      const autoNavigate = setTimeout(() => {
        handleConfirm();
      }, 3000);
      return () => clearTimeout(autoNavigate);
    }
  }, [result, handleConfirm]);

  if (!match || !amount) {
    return (
      <div className="wheel-screen">
        <div className="error-message">Invalid bet details</div>
      </div>
    );
  }

  return (
    <div className="wheel-screen">
      <div className="wheel-container">
        <div className="wheel" ref={wheelRef}>
          {[...Array(15)].map((_, i) => (
            <div 
              key={i} 
              className="wheel-segment"
              style={{ transform: `rotate(${i * (360 / 15)}deg)` }}
              onMouseEnter={() => handleSegmentHover(i)}
              onMouseLeave={handleSegmentLeave}
            >
              <div className="segment-value">{15 - i}x</div>
            </div>
          ))}
        </div>
        <div className="wheel-pointer"></div>
      </div>

      <div className="bet-info">
        <div className="bet-amount">
          <span>Stake Amount:</span>
          <span className="amount">₹{amount}</span>
        </div>
        {result && (
          <>
            <div className="result">
              <span>Multiplier:</span>
              <span className="multiplier">{result}x</span>
            </div>
            <div className="result">
              <span>Total Winnings:</span>
              <span className="multiplier">₹{amount * result}</span>
            </div>
          </>
        )}
      </div>

      <div className="action-buttons">
        {!result ? (
          <button 
            className="spin-button"
            onClick={handleSpin}
            disabled={isSpinning}
          >
            {isSpinning ? (
              <>
                <span className="spinner"></span>
                Spinning...
              </>
            ) : (
              'Spin Wheel'
            )}
          </button>
        ) : (
          <button 
            className="confirm-button"
            style={{ width: '100%' }}
            onClick={handleConfirm}
          >
            Confirm
          </button>
        )}
      </div>

      {showConfetti && (
        <div className="confetti-container">
          {[...Array(50)].map((_, i) => (
            <div 
              key={i}
              className="confetti"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                backgroundColor: `hsl(${Math.random() * 360}, 100%, 50%)`
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default WheelScreen;
